<template>
  <div class="AppSberCreditOfferInfo" v-if="option">
    <div
      v-if="$options.PRODUCT_CODE_CREDIT.includes(option.code)"
      class="AppSberCreditOfferInfo__block"
    >
      <h3 class="AppSberCreditOfferInfo__title">Оплата в кредит:</h3>
      <!--
      <span class="AppSberCreditOfferInfo__text">
        В кредит от
        {{
          paymentAmountsPerMonth(
            +(option.rate / 1200).toFixed(3),
            option.termMax,
            option.sumMin,
            option.sumMax
          ) | price()
        }}
        руб. в месяц
      </span> -->
      <span class="AppSberCreditOfferInfo__text">
        {{ (option.rate / 12).toFixed(1) }}% в месяц, до
        {{ option.sumMax / 1000000 }} млн
      </span>
      <span
        class="AppSberCreditOfferInfo__text AppSberCreditOfferInfo__text--gray"
      >
        От ПАО Сбербанк
      </span>
    </div>
    <div
      v-else-if="$options.PRODUCT_CODE_VCL.includes(option.code)"
      class="AppSberCreditOfferInfo__block"
    >
      <h3 class="AppSberCreditOfferInfo__title">Оплата в кредит:</h3>
      <!-- <span class="AppSberCreditOfferInfo__text">
        Покупка в рассрочку на {{ option.delayRepayment }} дней без процентов
      </span>
      <span class="AppSberCreditOfferInfo__text">
        {{ (option.rate / 12).toFixed(1) }}% c
        {{ +option.delayRepayment + 1 }}-го дня, до
        {{ option.sumMax | price() }} руб.
      </span> -->

      <span class="AppSberCreditOfferInfo__text">
        {{ (option.rate / 12).toFixed(1) }}% в месяц, до
        {{ option.sumMax / 1000000 }} млн
      </span>
      <span
        class="AppSberCreditOfferInfo__text AppSberCreditOfferInfo__text--gray"
      >
        От ПАО Сбербанк
      </span>
    </div>
    <div v-else class="AppSberCreditOfferInfo__block">
      <!-- <h3 class="AppSberCreditOfferInfo__text">
        {{ option.productName }}
      </h3> -->
      <h3 class="AppSberCreditOfferInfo__title">Оплата в кредит:</h3>
      <span class="AppSberCreditOfferInfo__text">
        {{ (option.rate / 12).toFixed(1) }}% в месяц, до
        {{ option.sumMax / 1000000 }} млн
      </span>
      <span
        class="AppSberCreditOfferInfo__text AppSberCreditOfferInfo__text--gray"
      >
        От ПАО Сбербанк
      </span>
    </div>
  </div>
</template>

<script>
import { PRODUCT_CODE_VCL, PRODUCT_CODE_CREDIT } from '@/helpers/enums/sber';

export default {
  name: 'AppSberCreditOffers',
  props: {
    option: {
      required: true,
      type: Object,
    },
    response: {
      type: Object,
      require: true,
    },
  },
  created() {
    this.$options.PRODUCT_CODE_VCL = PRODUCT_CODE_VCL;
    this.$options.PRODUCT_CODE_CREDIT = PRODUCT_CODE_CREDIT;
  },
  methods: {
    /**
     * Расчёт суммы оплаты в месяц по данному кредитному предложению
     * @param i -  месячная процентная ставка по кредиту  rate / 1200
     * @param n -  количество периодов, в течение которых выплачивается кредит TermMax
     * @param min - минимальная сумма кредита
     * @param max - максимальная сумма кредита
     */
    paymentAmountsPerMonth(i, n, min, max) {
      // eslint-disable-next-line no-restricted-properties
      // const expression = +Math.pow(1 + +i, n).toFixed(3);
      const expression = +((1 + +i) ** n).toFixed(3);
      const K = +((i * expression) / (expression - 1)).toFixed(3);
      const minTonne = this.setVolumeLimits({ min, max }).tn.min;
      const total = this.response.pricePerTonne * minTonne;
      return +(K * total).toFixed(0);
    },

    /**
     * TODO: вынести в хелпер
     * Установка максимального лимимта по объему
     * @param value данные выбранного кредита
     */
    setVolumeLimits(value) {
      const offerTonneLimitMin = this.response.volumeLimits.tn.min;
      const offerTonneLimitMax =
        this.response.volumeLimits.tn.max === 0
          ? 50
          : this.response.volumeLimits.tn.max;
      const offerLiterLimitMin = this.response.volumeLimits.lt.min;
      const offerLiterLimitMax =
        this.response.volumeLimits.lt.max === 0
          ? 50000
          : this.response.volumeLimits.lt.max;
      const offerPcLimitMin = this.response.volumeLimits.pc.min;
      const offerPcLimitMax = this.response.volumeLimits.pc.max;
      let minTonne = +(value.min / this.response.pricePerTonne).toFixed(0);
      let maxTonne = +(value.max / this.response.pricePerTonne).toFixed(0);

      let minLiter = +(value.min / this.response.pricePerLiter).toFixed(0);
      let maxLiter = +(value.max / this.response.pricePerLiter).toFixed(0);

      minTonne = minTonne >= offerTonneLimitMin ? minTonne : offerTonneLimitMin;
      maxTonne = maxTonne <= offerTonneLimitMax ? maxTonne : offerTonneLimitMax;

      minLiter = minLiter >= offerLiterLimitMin ? minLiter : offerLiterLimitMin;
      maxLiter = maxLiter <= offerLiterLimitMax ? maxLiter : offerLiterLimitMax;
      return {
        tn: { min: minTonne === 0 ? 1 : minTonne, max: maxTonne },
        lt: { min: minLiter === 0 ? 1000 : minLiter, max: maxLiter },
        pc: { min: offerPcLimitMin, max: offerPcLimitMax },
      };
    },
  },
};
</script>

<style scoped lang="scss">
.AppSberCreditOfferInfo {
  display: flex;
  align-items: center;
  height: 174px;
  padding-right: 15px;
  padding-left: 153px;
  background: #fafafa;
  background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTIiIGhlaWdodD0iOTMiIHZpZXdCb3g9IjAgMCA5MiA5MyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgb3BhY2l0eT0iMC4yIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00Ni4wMDIzIDBDNTcuMDU2NyAwIDY3LjIwMDIgMy44OTY0IDc1LjEzMSAxMC4zOTY1TDY3LjIwOTQgMTYuNzMxQzYxLjI1MjEgMTIuNDA2OCA1My45MjM5IDkuODU4MjkgNDUuOTk3NyA5Ljg1ODI5QzI2LjAzMjcgOS44NTgyOSA5Ljg1MzY5IDI2LjA0MTkgOS44NTM2OSA0Ni4wMDIzQzkuODUzNjkgNjUuOTY3MyAyNi4wMzczIDgyLjE0NjMgNDUuOTk3NyA4Mi4xNDYzQzY1Ljk2MjcgODIuMTQ2MyA4Mi4xNDE3IDY1Ljk2MjcgODIuMTQxNyA0Ni4wMDIzQzgyLjE0MTcgNDUuNTQyMyA4Mi4xMzI1IDQ1LjA4MjMgODIuMTE4NyA0NC42MjIyTDkxLjMwNTQgMzcuOTg4N0M5MS43NjU0IDQwLjU5MjQgOTIgNDMuMjY5OCA5MiA0Ni4wMDIzQzkyIDcxLjQwOTQgNzEuNDA0OCA5Mi4wMDQ2IDQ1Ljk5NzcgOTIuMDA0NkMyMC41OTA2IDkyLjAwNDYgMCA3MS40MDk0IDAgNDYuMDAyM0MwIDIwLjU5NTIgMjAuNTk1MiAwIDQ2LjAwMjMgMFoiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcikiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yOC42OTc1IDM0Ljc5MDlMNDYuMDAzNiA0Ni4wMDE2TDgzLjM0ODMgMTguNjMwMkw4OC44OTYxIDI3LjY0MjFMNDYuMDAzNiA1OC45ODgxTDI4LjY5NzUgNDguMTg2N1YzNC43OTA5WiIgZmlsbD0iIzIyOUUzOSIvPgo8L2c+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXIiIHgxPSI1My41MTQ2IiB5MT0iLTEuODIxMTZlLTA2IiB4Mj0iNC43ODcyOSIgeTI9IjY1LjY5MzYiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzAxODdDOCIvPgo8c3RvcCBvZmZzZXQ9IjAuMzEzMzIiIHN0b3AtY29sb3I9IiMwOEE2NTIiLz4KPHN0b3Agb2Zmc2V0PSIwLjcyMzg0IiBzdG9wLWNvbG9yPSIjMDhBNjUyIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI0ZBRUYyMyIvPgo8L2xpbmVhckdyYWRpZW50Pgo8L2RlZnM+Cjwvc3ZnPgo=');
  background-repeat: no-repeat;
  background-position: calc(0% + 27px) center;
  background-size: 99px;
  border-radius: 25px;

  @include media-xl() {
    padding-left: 110px;
    background-size: 60px;
  }

  @include media-md() {
    padding-left: 153px;
    background-size: 99px;
  }

  @include media-xxs {
    padding: 0 20px;
    background-image: none;
  }

  &__block {
    display: flex;
    flex-direction: column;
  }

  &__title {
    @include h-reset;

    margin-bottom: 20px;
    font-size: rem(14);
    font-weight: 300;
    line-height: 18px;
    letter-spacing: 2%;

    @include media-xxs {
      margin-bottom: 10px;
      font-size: rem(13);
    }
  }

  &__text {
    margin: 0;
    font-size: rem(14);
    font-weight: 300;
    line-height: 20px;
    letter-spacing: 2%;

    @include media-xxs {
      font-size: rem(13);
    }

    &--gray {
      color: $color-gray-17;
    }
  }
}
</style>
